<div class="container-fluid">
  <app-pagetitle title="User Master" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>


  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <!-- <h4 class="card-title">Purchase Order List</h4> -->

          <div class="row mb-md-2">
            <div class="col-sm-12 col-md-6">
              <button type="button" class="btn btn-primary tblebtn w-md" (click)="resetAndopenModal(addmstModal)"><i
                  class="mdi mdi-plus"></i>Add New</button>

              <!-- <div class="dataTables_length" id="tickets-table_length"><label
                  class="d-inline-flex align-items-center">Show
                  <select name="tickets-table_length" aria-controls="tickets-table" name="pageSize"
                    [(ngModel)]="service.pageSize"
                    class="custom-select custom-select-sm form-control form-control-sm mx-2">
                    <option [ngValue]="10">10</option>
                    <option [ngValue]="25">25</option>
                    <option [ngValue]="50">50</option>
                    <option [ngValue]="100">100</option>
                  </select> entries</label></div> -->
            </div>
            <!-- Search -->
            <div class="col-sm-12 col-md-6">
              <div class="row navbar">
                <div class="col-6 d-flex justify-content-left">
                </div>
                <div class="col-6 d-flex justify-content-end">
                  <div class="row">
                    <div>
                      <input class="form-control" [(ngModel)]="searchString" placeholder="Search" id="searchString"
                        name="searchString" (keyup)="searchExistingRecords($event)" />
                    </div>
                    <!-- <div>
                            <button class="btn btn-primary" (click)="searchDBRecords()"><i
                                    class="ti-search m-r-5 m-l-5"></i></button>
                        </div> -->
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive">
              <table #table class="table table-hover m-t-20 table-bordered">
                <thead class="bg-info text-white">
                  <tr class="">
                    <th>User Name</th>
                    <th>Name</th>
                    <th>Role</th>
                    <th>Email ID</th>
                    <th>Created By</th>
                    <th>Active</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody class="border border-info">
                  <tr *ngFor="let item of work">

                    <td>{{item.UserName}}</td>
                    <td>{{item.Name}}</td>
                    <td>{{item.RoleName}}</td>
                    <td>{{item.EmailID}}</td>
                    <td>{{item.CreatedBy}}</td>
                    <td>{{item.IsActive}}</td>
                    <td>
                      <a href="javascript:void(0);" (click)="editRecord(item.UserID,addmstModal)" class="text-primary"
                        ngbTooltip="Edit"><i class="mdi mdi-file-document-edit-outline font-size-22 "></i></a>

                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <ngb-pagination [collectionSize]="pager.totalItems " [pageSize]="pager.pageSize "
              [(page)]="pager.currentPage " [maxSize]="10 " [rotate]="true " (pageChange)="setPage(pager.currentPage) "
              [boundaryLinks]="true ">
            </ngb-pagination>

          </div>
        </div>
      </div>
    </div>
  </div>



    <!-- Modal -->
    <ng-template #addmstModal let-modal>
      <div class="modal-header">
        <h5 class="modal-title mt-0">User Setup</h5>
        <button type="button" class="close" (click)="modal.dismiss('Cross click')" aria-hidden="true">×</button>
      </div>
      <div class="modal-body">
        <form class="needs-validation" (ngSubmit)="validSubmit()" [formGroup]="validationform">
          <div class="row">
            <div class="col-lg-12">
              <div class="card o">
                <div class="card-body o">
                  <div class="row">
                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="UserName">User Name</label>
                        <input class="form-control" formControlName="UserName" id="UserName"
                          [ngClass]="{'is-invalid': submit && form.UserName.errors}">
                        <div *ngIf="submit && form.UserName.errors" class="invalid-feedback">
                          Please provide User Name
                        </div>
                      </div>
                    </div>

                    <div class="col-md-5">
                      <div class="form-group">
                        <label for="Name">Name</label>
                        <input class="form-control" formControlName="Name" id="Name"
                          [ngClass]="{'is-invalid': submit && form.Name.errors}">
                        <div *ngIf="submit && form.Name.errors" class="invalid-feedback">
                          Please provide Name
                        </div>
                      </div>
                    </div>

                    <div class="col-md-3">
                      <div class="form-group">
                        <label for="ActiveTag">Active</label>
                        <ng-select formControlName="ActiveTag" name="ActiveTag" id="ActiveTag" 
                     [(ngModel)]="ActiveTagModel"   [items]="ActiveTagList"  bindLabel="Name" bindValue="Code"></ng-select>
                      </div>
    
                    </div>
 
                   </div>

                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="EmailID">Email ID</label>
                        <input class="form-control" formControlName="EmailID" id="EmailID"
                          [ngClass]="{'is-invalid': submit && form.EmailID.errors}">
                        <div *ngIf="submit && form.EmailID.errors" class="invalid-feedback">
                          Please provide Email ID
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <div class="form-group">
                        <label for="RoleId">User Role</label>
                        <ng-select formControlName="RoleId" name="RoleId" id="RoleId"
                        [items]="RoleList"  bindLabel="Name" bindValue="RoleID"></ng-select>
                      </div>
                    </div>

                  </div>


         
                <div class="row">
                  <div class="col-md-7">
                  </div>
                  <div class="col-md-5">
                    <button type="submit" class="btn btn-primary tblebtn w-md">
                      Save
                    </button>&nbsp;
                    <button type="button" (click)="modal.dismiss('Cross click')" class="btn btn-secondary tblebtn w-md">
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </ng-template>
  </div>